// import React from "react";
// import Slider from "react-slick";
// import "../styles/Hero.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import hirsch from '../assets/hirsch.png';
// import Saisonstart from '../assets/Saisonstart_Klasse A_1080x1080.jpg';
// import Pfingsten from '../assets/Pfingsten_Kampagne_1000x630.png';
// import Kurse from '../assets/Banner_Laufend_Kurse.png';
// import Garantie from '../assets/Banner_Garantie.png';
// import Sommer from '../assets/Banner_Sommer.png';
// import Herbst from '../assets/Banner_Herbst.png';
// import { Link } from "react-router-dom"; 


// const Hero = () => {
//     const sliderSettings = {
//         dots: true,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 5000
//     }

//     return (
//         <div className="hero-container">
//             <div className="marketing">
//                 <Slider className="slider" {...sliderSettings}>
//                     <div><img src={Herbst} alt="Saisonstart Klasse A" /></div>
//                     <div><img src={Kurse} alt="Saisonstart Klasse A" /></div>
//                     <div><img src={Garantie} alt="Saisonstart Klasse A" /></div>
//                 </Slider>
//                 {/* <div className="marketing-nav">
//                     <button className="slide-nav active"></button>
//                     <button className="slide-nav"></button>
//                 </div> */}
//             </div>
//             <div className="cards">
//                 <Link to="/angebot" className="card-wrapper" style={{ textDecoration: 'none', color: 'white' }}>
//                     <div className="card-main">
//                         <div>Führerschein <br /> Konfigurator</div>
//                         <div className="arrow">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M646-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h446L532-634q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T589-691l183 183q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L589-269q-12 12-28.5 11.5T532-270q-11-12-11.5-28t11.5-28l114-114Z"/></svg>
//                         </div>
//                     </div>
//                 </Link>
//                 <Link to="/kurzkurse" className="card-wrapper" style={{ textDecoration: 'none', color: 'white' }}>
//                     <div className="card-main">
//                         {/* <div>Unsere Ferien <br /> Kurz-Kurse</div> */}
//                         <div>Ferien Kurse Klasse B</div>
//                         <div className="arrow">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M646-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h446L532-634q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T589-691l183 183q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L589-269q-12 12-28.5 11.5T532-270q-11-12-11.5-28t11.5-28l114-114Z"/></svg>
//                         </div>
//                     </div>
//                 </Link>
//                 <div className="card-wrapper">
//                     <div className="card-main">
//                         <Link to='/kursplan' style={{ textDecoration: 'none', color: 'white' }}>
//                             <div>Zu unserem <br /> Kursplan</div>
//                             <div className="arrow">
//                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M646-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h446L532-634q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T589-691l183 183q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L589-269q-12 12-28.5 11.5T532-270q-11-12-11.5-28t11.5-28l114-114Z"/></svg>
//                             </div>
//                         </Link>
//                     </div>
//                 </div>
//                 <Link to="/klassen" className="card-wrapper" style={{ textDecoration: 'none', color: 'white' }}>
//                     <div className="card-main">
//                         <div>Alle Klassen <br /> im Detail</div>
//                         <div className="arrow">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M646-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h446L532-634q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T589-691l183 183q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L589-269q-12 12-28.5 11.5T532-270q-11-12-11.5-28t11.5-28l114-114Z"/></svg>
//                         </div>
//                     </div>
//                 </Link>
//             </div>

//         </div>
//     );
// };

// export default Hero;



// src/components/Hero.jsx (или где у вас лежит Hero)
import React, { useContext } from "react";
import Slider from "react-slick";
import "../styles/Hero.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

import { HomeSliderContext } from "../contexts/HomeSliderContext";

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M646-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h446L532-634q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T589-691l183 183q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L589-269q-12 12-28.5 11.5T532-270q-11-12-11.5-28t11.5-28l114-114Z" />
  </svg>
);

const Hero = () => {
  const { slider, loading, error } = useContext(HomeSliderContext);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    // если картинок 0/1 — лучше выключить infinite, чтобы не было странностей
    // но оставляю infinite как у вас; ниже есть защита
  };

  const hasSlides = Array.isArray(slider) && slider.length > 0;

  const date = new Date();
  const now = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();

  console.log(now);

  return (
    <div className="hero-container">
      <div className="marketing">
        {loading ? (
          // простая заглушка, можно заменить на ваш Loader/скелетон
          <div style={{ minHeight: 220 }} />
        ) : error ? (
          <div className="error">{error}</div>
        ) : hasSlides ? (
          <Slider
            className="slider"
            {...{
              ...sliderSettings,
              infinite: slider.length > 1,
              dots: slider.length > 1,
              autoplay: slider.length > 1,
            }}
          >
            {slider
              .filter((p) => (p.Start_Datum < now || p.Start_Datum === null) && (p.End_Datum > now || p.End_Datum === null))
              .map((p) => (
              <div key={p.id}>
                {p.Image_Link ? (
                  <a href={p.Image_Link}>
                    <img className="desktopSlide" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${p.Desktop_Image.filename_disk}`} alt={p.alt || "Slide"} />
                    <img className="mobileSlide" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${p.Mobile_Image.filename_disk}`} alt={p.alt || "Slide"} />
                  </a>
                ) : (
                  <>
                    <img className="desktopSlide" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${p.Desktop_Image.filename_disk}`} alt={p.alt || "Slide"} />
                    <img className="mobileSlide" src={`${process.env.REACT_APP_API_BASE_URL}/assets/${p.Mobile_Image.filename_disk}`} alt={p.alt || "Slide"} />
                  </>
                )}
              </div>
            ))}
          </Slider>
        ) : (
          <div style={{ minHeight: 220 }} />
        )}
      </div>

      <div className="cards">
        <Link
          to="/angebot"
          className="card-wrapper"
          style={{ textDecoration: "none", color: "white" }}
        >
          <div className="card-main">
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="var(--primary)"><path d="M720-440q17 0 28.5-11.5T760-480q0-17-11.5-28.5T720-520H600q-17 0-28.5 11.5T560-480q0 17 11.5 28.5T600-440h120Zm0-120q17 0 28.5-11.5T760-600q0-17-11.5-28.5T720-640H600q-17 0-28.5 11.5T560-600q0 17 11.5 28.5T600-560h120ZM360-440q-36 0-65 6.5T244-413q-21 13-32 29.5T201-348q0 12 9 20t22 8h256q13 0 22-8.5t9-21.5q0-17-11-33t-32-30q-22-14-51-20.5t-65-6.5Zm56.5-63.5Q440-527 440-560t-23.5-56.5Q393-640 360-640t-56.5 23.5Q280-593 280-560t23.5 56.5Q327-480 360-480t56.5-23.5ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"/></svg>
            </div>
            <div className="title">
              Führerschein Konfigurator
            </div>
            <div className="descr">Starte noch heute deinen Weg</div>
            <div className="arrow">
              <ArrowIcon />
            </div>
          </div>
        </Link>

        <Link
          to="/klassen"
          className="card-wrapper"
          style={{ textDecoration: "none", color: "white" }}
        >
          <div className="card-main">
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="var(--primary)"><path d="M508.5-291.5Q520-303 520-320v-160q0-17-11.5-28.5T480-520q-17 0-28.5 11.5T440-480v160q0 17 11.5 28.5T480-280q17 0 28.5-11.5Zm0-320Q520-623 520-640t-11.5-28.5Q497-680 480-680t-28.5 11.5Q440-657 440-640t11.5 28.5Q463-600 480-600t28.5-11.5ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
            </div>
            <div className="title">
              Alle Klassen <br /> im Detail
            </div>
            <div className="descr">Starte noch heute deinen Weg</div>
            <div className="arrow">
              <ArrowIcon />
            </div>
          </div>
        </Link>

        <Link
          to="/kursplan"
          className="card-wrapper"
          style={{ textDecoration: "none", color: "white" }}
        >
          <div className="card-main">
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="var(--primary)"><path d="M509-269q-29-29-29-71t29-71q29-29 71-29t71 29q29 29 29 71t-29 71q-29 29-71 29t-71-29ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880q17 0 28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880q17 0 28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>
            </div>
            <div className="title">
              Zu unserem <br /> Kursplan
            </div>
            <div className="descr">Starte noch heute deinen Weg</div>
            <div className="arrow">
              <ArrowIcon />
            </div>
          </div>
        </Link>

        <Link
          to="/kurzkurse"
          className="card-wrapper card-ferienkurse"
          style={{ textDecoration: "none", color: "white" }}
        >
          <div className="card-main">
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="var(--primary)"><path d="M600-160q-134 0-227-93t-93-227q0-133 93-226.5T600-800q133 0 226.5 93.5T920-480q0 134-93.5 227T600-160Zm0-80q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70Zm40-256v-104q0-17-11.5-28.5T600-640q-17 0-28.5 11.5T560-600v121q0 8 3.5 15.5T572-451l91 91q12 12 28.5 12t28.5-12q12-12 12-28.5T720-417l-80-79ZM120-600q-17 0-28.5-11.5T80-640q0-17 11.5-28.5T120-680h80q17 0 28.5 11.5T240-640q0 17-11.5 28.5T200-600h-80ZM80-440q-17 0-28.5-11.5T40-480q0-17 11.5-28.5T80-520h120q17 0 28.5 11.5T240-480q0 17-11.5 28.5T200-440H80Zm40 160q-17 0-28.5-11.5T80-320q0-17 11.5-28.5T120-360h80q17 0 28.5 11.5T240-320q0 17-11.5 28.5T200-280h-80Zm480-200Z"/></svg>
            </div>
            <div className="title">Ferien Kurse<br /> Klasse B</div>
            <div className="descr">Starte noch heute deinen Weg</div>
            <div className="arrow">
              <ArrowIcon />
            </div>
          </div>
        </Link>

        <Link
          to="/beratung"
          className="card-wrapper card-beratung"
          style={{ textDecoration: "none", color: "white" }}
        >
          <div className="card-main">
            <div className="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="var(--primary)"><path d="M600-160q-134 0-227-93t-93-227q0-133 93-226.5T600-800q133 0 226.5 93.5T920-480q0 134-93.5 227T600-160Zm0-80q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70Zm40-256v-104q0-17-11.5-28.5T600-640q-17 0-28.5 11.5T560-600v121q0 8 3.5 15.5T572-451l91 91q12 12 28.5 12t28.5-12q12-12 12-28.5T720-417l-80-79ZM120-600q-17 0-28.5-11.5T80-640q0-17 11.5-28.5T120-680h80q17 0 28.5 11.5T240-640q0 17-11.5 28.5T200-600h-80ZM80-440q-17 0-28.5-11.5T40-480q0-17 11.5-28.5T80-520h120q17 0 28.5 11.5T240-480q0 17-11.5 28.5T200-440H80Zm40 160q-17 0-28.5-11.5T80-320q0-17 11.5-28.5T120-360h80q17 0 28.5 11.5T240-320q0 17-11.5 28.5T200-280h-80Zm480-200Z"/></svg>
            </div>
            <div className="title">Beratungstermin<br /> buchen</div>
            <div className="descr">Starte noch heute deinen Weg</div>
            <div className="arrow">
              <ArrowIcon />
            </div>
          </div>
        </Link>

      </div>
    </div>
  );
};

export default Hero;

